/* eslint-disable @next/next/no-img-element */
"use client";

import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { useRef, useState } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
import DynamicSizeIcon from "@/components/DynamicSizeIcon";
import DynamicFontSize from "@/components/DynamicFontSize";
import OtpInputComponent from "@/components/OtpInput";
import DetailPageLayout from "@/layouts/DetailPageLayout";
import PageHeader from "@/components/PageHeader";
import { useAuth } from "@/contexts/Auth";
import PrimaryButton from "@/components/PrimaryButton";
import Link from "next/link";
import { ComfirmClaimContentHelper } from "../ComfirmClaim";
import RequireData from "../RequireData";
import clsx from "clsx";
import PasswordInput from "../PasswordInput";
import { InputKeyboard, Keyboard, KeyboardRef, KeyboardType, THEME } from "tek-input-keyboard";
type step = "auth" | "change" | "success";
export default function ChangePasswordLogin(props: {
  initStep?: step;
  prefix?: string;
}) {
  const prefix = props.prefix || "change_password_login_";
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const {
    translate,
    getIcon,
    authenInfo
  } = useGlobalData();
  const {
    loginAppData,
    setLoginAppStep,
    updateLoginAppData
  } = useAuth();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageConfirm, setErrorMessageConfirm] = useState("");
  const [changePasswordStep, setChangePasswordStep] = useState<step>(props.initStep || "auth");
  const [focusConfirm, setFocusConfirm] = useState(false);
  const confirmOTPRef = useRef<any>(null);
  const keyboardRef = useRef<KeyboardRef>(null);
  const blurAllInputs = () => {
    document.querySelectorAll("input").forEach(input => {
      input.blur?.();
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const handlePasswordChange = (value: string) => {
    if (value?.length > 6) return;
    setPassword(value);
    if (value?.length === 6) {
      if (value != loginAppData?.password) {
        setErrorMessage(translate(prefix + "password is incorrect"));
        setPassword("");
        setChangePasswordStep("auth");
      } else {
        blurAllInputs();
        setTimeout(() => {
          setChangePasswordStep("change");
        }, 300);
        setErrorMessage("");
      }
    }
  };
  const handleNewPasswordChange = async (value: string) => {
    if (value?.length > 6) return;
    setNewPassword(value);
  };
  const handleNewPasswordConfirmChange = (value: string) => {
    if (value?.length > 6) return;
    setNewPasswordConfirm(value);
    if (!newPasswordConfirm && !newPassword) {
      setErrorMessageConfirm("");
      return;
    }
    if (value?.length === 6) {
      if (value != newPassword) {
        setErrorMessageConfirm(translate(prefix + "password not match"));
        setNewPasswordConfirm("");
      } else {
        blurAllInputs();
        updateLoginAppData({
          password: value
        });
        setErrorMessageConfirm("");
        setChangePasswordStep("success");
      }
    }
  };
  return <RequireData showLoading={!authenInfo} className="" data-sentry-element="RequireData" data-sentry-component="ChangePasswordLogin" data-sentry-source-file="page.tsx">
            {authenInfo?.status != "active" && <DetailPageLayout header={<PageHeader>{translate(prefix + "Password")}</PageHeader>}>
                    <DefaultPageLayout className="flex flex-1 !pb-8">
                        <ComfirmClaimContentHelper className="pt-4 w-full" contentTitle={translate("helper email heading")} contentDescription={translate("helper email description")} buttonClassName="mt-auto" />
                    </DefaultPageLayout>
                </DetailPageLayout>}
            {authenInfo?.status == "active" && <>
                    {changePasswordStep === "auth" && <Keyboard keyboardType={KeyboardType.Text} value={password} ref={keyboardRef} toolbarFullHeight theme={THEME.DARK} alwaysOpen onChange={value => {
        handlePasswordChange(value);
      }} toolbar={<DetailPageLayout disabledAnimation header={<PageHeader>{translate(prefix + "Password")}</PageHeader>} containerClassName="static h-full">
                                    <div className="w-full flex flex-col items-center justify-center h-full">
                                        <div className="flex-1 flex flex-col items-center justify-center py-6 px-4">
                                            <div className="!w-[350px] flex flex-col py-6 px-4 flex-1 gap-3 items-center justify-center text-white">
                                                <DynamicFontSize fontSize={12}>
                                                    {translate(prefix + "enter your old password")}
                                                </DynamicFontSize>

                                                <PasswordInput type="password" value={password} readOnly />
                                                {errorMessage && !password && <DynamicFontSize fontSize={12} className="text-error ">
                                                        {errorMessage}
                                                    </DynamicFontSize>}
                                            </div>
                                        </div>
                                    </div>
                                </DetailPageLayout>} />}
                    {changePasswordStep === "change" && <>
                            {newPassword?.length != 6 && <Keyboard keyboardType={KeyboardType.Text} value={newPassword} toolbarFullHeight theme={THEME.DARK} alwaysOpen onChange={value => {
          handleNewPasswordChange(value);
        }} toolbar={<DetailPageLayout disabledAnimation header={<PageHeader>{translate(prefix + "Password")}</PageHeader>} containerClassName="static h-full">
                                            <div className="w-full flex flex-col items-center justify-center h-full">
                                                <div className="!w-[350px] flex flex-col py-6 px-4 flex-1 gap-3 items-center justify-center text-white">
                                                    <DynamicFontSize fontSize={12}>
                                                        {translate(prefix + "enter your new password")}
                                                    </DynamicFontSize>
                                                    <PasswordInput readOnly type="password" value={newPassword} />
                                                </div>
                                            </div>
                                        </DetailPageLayout>} />}
                            {newPassword?.length == 6 && <Keyboard keyboardType={KeyboardType.Text} value={newPasswordConfirm} theme={THEME.DARK} alwaysOpen toolbarFullHeight onChange={value => {
          handleNewPasswordConfirmChange(value);
        }} toolbar={<DetailPageLayout disabledAnimation header={<PageHeader>{translate(prefix + "Password")}</PageHeader>} containerClassName="static h-full">
                                            <div className="w-full flex flex-col py-6 px-4 items-center justify-center h-full">
                                                <div className="!w-[350px] flex flex-col py-6 px-4 flex-1 gap-3 items-center justify-center text-white">
                                                    <DynamicFontSize fontSize={12}>
                                                        {translate(prefix + "enter your new password confirm")}
                                                    </DynamicFontSize>
                                                    <PasswordInput type="password" value={newPasswordConfirm} readOnly />
                                                    {errorMessageConfirm && !newPasswordConfirm && <DynamicFontSize fontSize={12} className="text-error">
                                                            {errorMessageConfirm}
                                                        </DynamicFontSize>}
                                                </div>
                                            </div>
                                        </DetailPageLayout>} />}
                        </>}
                    {changePasswordStep === "success" && <DetailPageLayout disabledAnimation>
                            <DefaultPageLayout className="flex flex-col gap-3 items-center flex-1 justify-center !pb-9">
                                <div className="flex flex-col gap-1 items-center my-auto">
                                    <DynamicSizeIcon icon={getIcon(prefix + "icon_success")} width={100}></DynamicSizeIcon>
                                    <DynamicFontSize fontSize={18} className="text-white font-medium">
                                        {translate(prefix + "title success")}
                                    </DynamicFontSize>
                                    <DynamicFontSize fontSize={12} className="text-white">
                                        {translate(prefix + "des success")}
                                    </DynamicFontSize>
                                </div>
                                <Link href="/setting/login-password" className="w-full" onClick={() => setLoginAppStep("logged")}>
                                    <PrimaryButton statusKey={prefix + "set_password"} className="w-full"></PrimaryButton>
                                </Link>
                            </DefaultPageLayout>
                        </DetailPageLayout>}
                </>}
        </RequireData>;
}